/**
 * Wonders Pets — Digisimma theme overlay (defensive, no custom cart/checkout)
 */
(function () {
  'use strict';

  function initAnnouncementClose() {
    document.querySelectorAll('[data-digi-wp-announce-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var bar = btn.closest('.digi-wp-announcement');
        if (bar) bar.hidden = true;
      });
    });
  }

  function initFaqEnhancements() {
    document.querySelectorAll('[data-digi-wp-faq] details').forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        var parent = item.closest('[data-digi-wp-faq]');
        if (!parent) return;
        parent.querySelectorAll('details[open]').forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });
  }

  // Les recommandations produits de Dawn se chargent sur IntersectionObserver.
  // Notre section de cross-sell n'occupe aucune hauteur tant qu'elle est vide,
  // pour ne pas laisser de bande de padding creuse, et l'observateur ne se
  // declenche alors pas. Verifie le 29/07/2026 : l'API renvoyait bien quatre
  // produits, le declenchement manuel de la meme methode les affichait, mais
  // l'observateur ne s'etait jamais reveille.
  // On appelle donc la methode publique de l'element de Dawn, une seule fois,
  // et seulement s'il est encore vide. Aucun fichier de Dawn n'est modifie.
  function initProductRecommendations() {
    var elements = document.querySelectorAll('product-recommendations[data-product-id]');
    if (!elements.length) return;
    elements.forEach(function (element) {
      if (element.innerHTML.trim().length) return;
      if (typeof element.loadRecommendations !== 'function') return;
      element.loadRecommendations(element.dataset.productId);
    });
  }

  // Descripteurs du panneau de navigation. Le rendu direct imposerait de
  // modifier sections/header.liquid de Dawn, qui ne connait qu'un libelle et
  // une adresse par entree. La table est donc publiee en donnees par le
  // snippet digi-wp-menu-data et appliquee ici. Sans JavaScript le menu reste
  // complet, il perd seulement ses descripteurs.
  function initMenuDescripteurs() {
    var source = document.getElementById('digi-wp-menu-desc');
    if (!source) return;
    var table;
    try {
      table = JSON.parse(source.textContent);
    } catch (e) {
      return;
    }
    var liens = document.querySelectorAll('.header__submenu a[href]');
    liens.forEach(function (lien) {
      if (lien.querySelector('.digi-wp-menu-desc')) return;
      var chemin = lien.getAttribute('href').split('?')[0].replace(/\/$/, '');
      var texte = table[chemin] || table[chemin + '/'];
      if (!texte) return;
      var span = document.createElement('span');
      span.className = 'digi-wp-menu-desc';
      span.textContent = texte;
      // aria-hidden : le libelle du lien suffit a le decrire, le descripteur
      // est une aide visuelle qui alourdirait l'annonce vocale.
      span.setAttribute('aria-hidden', 'true');
      lien.appendChild(span);
    });
  }

  function init() {
    initAnnouncementClose();
    initMenuDescripteurs();
    initFaqEnhancements();
    // Laisse a Dawn le temps de definir l'element personnalise.
    if (window.customElements && customElements.whenDefined) {
      customElements
        .whenDefined('product-recommendations')
        .then(initProductRecommendations)
        .catch(function () {});
    } else {
      initProductRecommendations();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();